module.exports = __webpack_public_path__ + "img/cutneck.d335cf6e.jpg";